import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { nextActions } from '../actions/next.actions';
import { selectNext, selectNextLoaded, selectNextLoading } from '../selectors/next.selectors';
import { filter } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NextFacade {
    private readonly store = inject(Store);

    readonly next$ = this.store.select(selectNext);
    readonly nextNonNullable$ = this.next$.pipe(filter((data) => data !== null));
    readonly nextLoading$ = this.store.select(selectNextLoading);
    readonly nextLoaded$ = this.store.select(selectNextLoaded);

    readonly next = this.store.selectSignal(selectNext);
    readonly loaded = this.store.selectSignal(selectNextLoaded);
    readonly loading = this.store.selectSignal(selectNextLoading);

    clear() {
        this.store.dispatch(nextActions.clear());
    }
}
